import { Divider } from "@mui/material";
import { useIntl } from "react-intl";

import type { HotelData } from "@/features/hotels/types/types";

type Props = {
  hotel: HotelData;
};

export const HotelContactDetails = ({ hotel }: Props) => {
  const intl = useIntl();

  return (
    <>
      <Divider
        sx={{
          borderColor: "var(--color-stroke-neutral-softer)",
          my: "calc(var(--spacing)*4)",
        }}
      />
      <div className="mb-4 font-medium text-text-tertiary">
        {intl.formatMessage({
          defaultMessage: "Contact details",
          description: "hotels.contactDetails",
        })}
      </div>
      <div className="flex flex-col justify-between gap-4 text-sm text-text-primary">
        {hotel.address && (
          <div className="flex justify-between gap-4">
            {intl.formatMessage({
              defaultMessage: "Address",
              description: "hotels.overview.address",
            })}
            <div className="flex w-210 flex-wrap justify-end">
              {hotel.address
                .split(",")
                .map((position: string, index: number) => (
                  <span key={position}>
                    {position}{" "}
                    {index <= hotel.address.split(",").length - 2 && "-"}
                  </span>
                ))}
            </div>
          </div>
        )}
        {hotel.email && (
          <div className="flex justify-between gap-4">
            {intl.formatMessage({
              defaultMessage: "Email",
              description: "hotels.overview.email",
            })}
            <span>{hotel.email}</span>
          </div>
        )}
        {hotel.telephone && (
          <div className="flex justify-between gap-4">
            {intl.formatMessage({
              defaultMessage: "Phone",
              description: "hotels.overview.telephone",
            })}
            <a
              className="text-text-interactive underline"
              href={`tel:${hotel.telephone}`}
            >
              {hotel.telephone}
            </a>
          </div>
        )}
      </div>
    </>
  );
};
